// 引入vue框架
import Vue from 'vue'
// 引入vue-router路由依赖
import Router from 'vue-router'
import storage from '@/utils/common/storage.js'
// Vue全局使用Router
Vue.use(Router)

// 定义路由配置
const router = new Router({
    routes: [                //配置路由，这里是个数组
        {                        //每一个链接都是一个对象
            path: '/',            //链接路径
            redirect: '/home'
        },
        {                        //每一个链接都是一个对象
            path: '/out',            //链接路径
            redirect: '/home'
        },
        {
            path: '*',
            component: () => import('@/pages/common/404'),
            meta: {
                title: '404',
                noLogin: true
            }
        },
        {
            path: '/login',
            component: () => import('@/pages/common/login'),
            meta: {
                title: '登录',
                noLogin: true
            }
        },
        {
            path: '/home',
            name: 'Home',
            redirect: '/home/index',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'index',
                    component: () => import('@/pages/home/index'),
                    meta: {
                        title: '首页'
                    }
                }
            ]
        },
        {
            path: '/eorder',
            name: 'eorder',
            redirect: '/eorder/index',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'index',
                    component: () => import('@/pages/eorder/index'),
                    meta: {
                        title: '所有运单'
                    }
                },
                {
                    path: 'pickup',
                    component: () => import('@/pages/eorder/pickup'),
                    meta: {
                        title: '待取运单'
                    }
                },
                {
                    path: 'add',
                    component: () => import('@/pages/eorder/add'),
                    meta: {
                        title: '新增系统运单'
                    }
                }
            ]
        },
        {
            path: '/partner',
            name: 'partner',
            redirect: '/partner/index',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'index',
                    component: () => import('@/pages/partner/index'),
                    meta: {
                        title: '代理商管理'
                    }
                }

            ]
        },
        {
            path: '/group',
            name: 'group',
            redirect: '/group/apply',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'apply',
                    component: () => import('@/pages/group/apply'),
                    meta: {
                        title: '开团申请'
                    }
                },
                {
                    path: 'applyDelivery',
                    component: () => import('@/pages/group/applyDelivery'),
                    meta: {
                        title: '截团申请'
                    }
                },
                {
                    path: 'working',
                    component: () => import('@/pages/group/working'),
                    meta: {
                        title: '进行中'
                    }
                },
                {
                    path: 'finish',
                    component: () => import('@/pages/group/finish'),
                    meta: {
                        title: '已截团'
                    }
                }
            ]
        },
        {
            path: '/user',
            name: 'User',
            redirect: '/user/index',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'index',
                    component: () => import('@/pages/user/index'),
                    meta: {
                        title: '客户管理'
                    }
                },
                {
                    path: 'detail',
                    component: () => import('@/pages/user/detail'),
                    meta: {
                        title: '客户详情'
                    }
                },
                {
                    path: 'blockUser',
                    component: () => import('@/pages/user/blockUser'),
                    meta: {
                        title: '黑名单用户'
                    }
                }
            ]
        },
        {
            path: '/coupon',
            name: 'Coupon',
            redirect: '/coupon/index',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'index',
                    component: () => import('@/pages/coupon/index'),
                    meta: {
                        title: '优惠券管理'
                    }
                }
            ]
        },
        {
            path: '/package',
            name: 'Package',
            redirect: '/package/index',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'index',
                    component: () => import('@/pages/package/index'),
                    meta: {
                        title: '仓库管理'
                    }
                }

            ]
        },
        {
            path: '/container',
            name: 'Container',
            redirect: '/container/index',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'index',
                    component: () => import('@/pages/container/index'),
                    meta: {
                        title: '货柜管理'
                    }
                }

            ]
        },
        {
            path: '/setting',
            name: 'Setting',
            redirect: '/package/index',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'fee',
                    component: () => import('@/pages/setting/fee'),
                    meta: {
                        title: '运费设置'
                    }
                },
                {
                    path: 'staff',
                    component: () => import('@/pages/setting/staff'),
                    meta: {
                        title: '员工设置'
                    }
                },
                {
                    path: 'guide',
                    component: () => import('@/pages/article/guide'),
                    meta: {
                        title: '新手教程'
                    }
                },
                {
                    path: 'about',
                    component: () => import('@/pages/article/about'),
                    meta: {
                        title: '关于我们'
                    }
                },


            ]
        },
        {
            path: '/print',
            name: 'Print',
            redirect: '/print/index',
            component: () => import('@/pages/common/full'),
            children: [ // 嵌套子路由
                {
                    path: 'index',
                    component: () => import('@/pages/print/index'),
                    meta: {
                        title: 'Printer'
                    }
                },
                {
                    path: 'group',
                    component: () => import('@/pages/print/group'),
                    meta: {
                        title: 'Printer'
                    }
                }
            ]
        },
        {
            path: '/finance',
            name: 'Finance',
            redirect: '/finance/normal',
            component: () => import('@/pages/common/normal'),
            children: [ // 嵌套子路由
                {
                    path: 'normal',
                    component: () => import('@/pages/finance/normal'),
                    meta: {
                        title: '普通运单与集运入账统计'
                    }
                },
                {
                    path: 'groupPayed',
                    component: () => import('@/pages/finance/groupPayed'),
                    meta: {
                        title: '集运拼团入账统计'
                    }
                },
                {
                    path: 'groupPaying',
                    component: () => import('@/pages/finance/groupPaying'),
                    meta: {
                        title: '集运拼团待支付统计'
                    }
                },
                {
                    path: 'balanceCharge',
                    component: () => import('@/pages/finance/balanceCharge'),
                    meta: {
                        title: '充值入账统计'
                    }
                },
                {
                    path: 'balanceExpend',
                    component: () => import('@/pages/finance/balanceExpend'),
                    meta: {
                        title: '充值金消费统计'
                    }
                }
            ]
        },
    ]
})

// 全局路由拦截-进入页面前执行
router.beforeEach((to, from, next) => {
    // 这里可以加入全局登陆判断
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (!to.meta.noLogin) {
        let token = storage.getToken()
        if (!token || token == 'none') {
            router.replace('/login?from=' + from.path)
        }
    }

    next();
});

// 全局后置钩子-常用于结束动画等
router.afterEach(() => {
    //不接受next
});

export default router;
